import { BNCC, ClassInfo, CurricularComponent, Grade } from '../../types/School';
import { getApi } from '../getApi/index';

export const getGrades = async (
  school_id: number,
  profileId: number,
): Promise<Grade[]> => {
  const { data } = await getApi().get<Grade[]>(
    `/options/grades?schoolId=${school_id}&profileId=${profileId}`,
  );
  return data;
};

export const getTeacherInfo = async (school_id: number): Promise<ClassInfo[]> => {
  const { data } = await getApi().get<ClassInfo[]>(
    `teacher/info?schoolId=${school_id}`,
  );
  return data;
};

export const getCurricularComponents = async (
  school_id?: number,
  profile_id?: number,
  class_id?: number,
): Promise<CurricularComponent[]> => {
  const { data } = await getApi().get<CurricularComponent[]>(
    `/options/curricular-components`,
    {
      params: {
        schoolId: school_id,
        profileId: profile_id,
        classId: class_id,
      },
    },
  );
  return data;
};

export const getBNCCByAreaId = async (componentId?: number, gradeId?: number) => {
  const { data } = await getApi().get<BNCC[]>(
    `/options/bncc?componentId=${componentId}`,
    {
      params: {
        gradeId: gradeId,
      },
    },
  );
  return data;
};
